import { render } from "./GruposDeUsuariosView.vue?vue&type=template&id=54e578f0"
import script from "./GruposDeUsuariosView.vue?vue&type=script&lang=js"
export * from "./GruposDeUsuariosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__